import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    wrapper: {
        height: '100%',
        position: 'relative',
    },
    notActiveWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#16181f',
    },
    startBtn: {
        width: 'calc(100% - 40px)',
    },
}))
